import React from "react";
import { Autocomplete, Box, Grid, TextField } from "@mui/material";
import FrostingAutocomplete from "../../../product/component/FrostingAutocomplete";
import ProductShapeAutocomplete from "../../../product/component/ProductShapeAutocomplete";
import ProductSizeAutocomplete from "../../../product/component/ProductSizeAutocomplete";
import ProductServingsAutocomplete from "../../../product/component/ProductServingsAutocomplete";
import { generateSizeSummary } from "../util";

export default function ItemVariantEntryV2(props) {
  const { productType, variant } = props;

  return (
    <Box>
      {productType === "Cake" && (
        <Box mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <ProductShapeAutocomplete
                productType={productType}
                label="Shape"
                value={variant?.size?.value?.shape}
                onChange={(val) => {
                  let value = { shape: val, size: "", servings: "" };
                  let size = { name: "", description: "", value };
                  size.name = generateSizeSummary(value);
                  props.onChange({ ...variant, size });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ProductSizeAutocomplete
                productType={productType}
                shape={variant?.size?.value?.shape}
                label="Size"
                value={variant?.size?.value?.size}
                onChange={(val) => {
                  let value = { shape: variant?.size?.value?.shape, size: val, servings: "" };
                  let size = { name: "", description: "", value };
                  size.name = generateSizeSummary(value, productType);

                  props.onChange({ ...variant, size });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ProductServingsAutocomplete
                productType={productType}
                shape={variant?.size?.value?.shape}
                size={variant?.size?.value?.size}
                label={"Servings"}
                value={variant?.size?.value?.servings}
                onChange={(val) => {
                  let value = { ...variant?.size?.value, servings: val };
                  let size = { name: "", description: "", value };
                  size.name = generateSizeSummary(value, productType);
                  props.onChange({ ...variant, size });
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FrostingAutocomplete
                productType={productType}
                value={variant.frosting?.name}
                label="Frosting"
                onChange={(val) => props.onChange({ ...variant, frosting: { name: val } })}
              />
            </Grid>
          </Grid>
        </Box>
      )}
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Autocomplete
              value={variant?.flavor?.name || ""}
              onChange={(e, val) => props.onChange({ ...variant, flavor: { name: val } })}
              onInputChange={(e, val) => props.onChange({ ...variant, flavor: { name: val } })}
              disableClearable={true}
              options={[]}
              renderInput={(params) => <TextField variant="outlined" {...params} label="Flavor" />}
              freeSolo
              blurOnSelect={true}
              autoSelect
            />
          </Grid>
          {productType === "Cake" && (
            <Grid item xs={12}>
              <Autocomplete
                value={variant?.filling?.name || ""}
                onChange={(e, val) => props.onChange({ ...variant, filling: { name: val } })}
                onInputChange={(e, val) => props.onChange({ ...variant, filling: { name: val } })}
                disableClearable={true}
                options={[]}
                renderInput={(params) => <TextField variant="outlined" {...params} label="Filling" />}
                freeSolo
                blurOnSelect={true}
                autoSelect
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
}
